import { PageContentOrders } from '@restaurant/core'
import { useWebOrdersPageViewModel } from '../viewmodels/pages/WebOrdersPageViewModel'

export default function OrdersPage() {
  const viewModel = useWebOrdersPageViewModel()

  // Use the ViewModel's built-in props getter which returns correctly formatted props
  const pageProps = viewModel.getPageContentOrdersProps()

  return (
    <PageContentOrders
      {...pageProps}
      testID="orders-page"
      accessibilityLabel="Order history page showing past orders"
    />
  )
}
